import { Copy, LogOut, Moon, PanelLeft, Zap } from 'lucide-react';
import type { NavigateFunction } from 'react-router-dom';
import { toast } from 'sonner';
import type { SyncCommandProvider } from '../types';

interface ActionDeps {
  toggleSidebar: () => void;
  toggleTheme: () => void;
  logout: () => Promise<void>;
  navigate: NavigateFunction;
}

export function createActionsProvider(deps: ActionDeps): SyncCommandProvider {
  return {
    id: 'shared:actions',
    kind: 'sync',
    label: 'Actions',
    icon: Zap,
    priority: 10,
    getItems: () => [
      {
        id: 'action:toggle-sidebar',
        label: 'Toggle Sidebar',
        icon: PanelLeft,
        onSelect: deps.toggleSidebar,
      },
      {
        id: 'action:toggle-theme',
        label: 'Toggle Theme',
        icon: Moon,
        onSelect: deps.toggleTheme,
      },
      {
        id: 'action:copy-url',
        label: 'Copy Current URL',
        icon: Copy,
        onSelect: () => {
          navigator.clipboard
            .writeText(window.location.href)
            .then(() => toast.success('URL copied to clipboard'))
            .catch(() => toast.error('Failed to copy URL'));
        },
      },
      {
        id: 'action:logout',
        label: 'Logout',
        icon: LogOut,
        onSelect: () =>
          deps
            .logout()
            .then(() => deps.navigate('/login?reason=logout'))
            .catch(() => {}),
      },
    ],
  };
}
